import { render, staticRenderFns } from "./MultiBlockHelpList.vue?vue&type=template&id=024f4b39&"
import script from "./MultiBlockHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiBlockHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports